    export const socketServerURL = 'https://bn.usplbot.com/';//'http://localhost:3030';//
    export const socketServerURLNifty = 'https://bn.usplbot.com/'; //'https://ni.usplbot.com/';//
    export const apiURL = 'https://siteservices.usplbot.com/'; //'http://localhost:5003/';//'http://services.usplbot.com/';
    export const token = '03ti9vnhmrwq0qhinzsw5jkj0cad97jtl1n0fpywzxloj4m0yi7kj9b0pk0m623r0elmq';
    export const DB_CONFIG = {
        // host: "95.217.128.43",
        // user: "dba",
        // database: "USPL",
        // password: "Sapl@1234",
        // connectTimeout: 60000,
        // multipleStatements: true,
        // timezone: "local",
        // connectionLimit: 150,
        // waitForConnections: true,
        // queueLimit: 0
    };
    console.log('Compo GlobalParameters.js loaded');
